// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-to-top {
  transform: translateX(100%);
  opacity: 0;
  transition: all 0.3s ease 0s;
  position: fixed;
  width: 40px;
  height: 40px;
  z-index: 999;
  right: 0;
  bottom: 125px;
  padding: 5px;
  background-color: rgba(0, 0, 0, 0.3);
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
}
.scroll-to-top:empty {
  display: none;
}
.scroll-to-top::before, .scroll-to-top::after {
  content: "";
  position: absolute;
  width: 10px;
  height: 2px;
  top: 50%;
  background-color: #fff;
}
.scroll-to-top::before {
  left: 13px;
  transform: translateY(-50%) rotate(-45deg);
}
.scroll-to-top::after {
  left: 19px;
  transform: translateY(-50%) rotate(45deg);
}
@media (max-width: 61.99875em) {
  .scroll-to-top {
    display: none;
  }
}
@media (any-hover: hover) {
  .scroll-to-top:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }
}

.scroll-to-top-enter {
  transition: all 0.3s ease 0s;
  transform: translateX(100%);
  opacity: 0;
}

.scroll-to-top-enter-active {
  transition: all 0.3s ease 0s;
  opacity: 1;
  transform: translateX(0%);
}

.scroll-to-top-enter-done {
  transition: all 0.3s ease 0s;
  opacity: 1;
  transform: translateX(0%);
}

.scroll-to-top-exit {
  opacity: 1;
  transform: translateX(0%);
}

.scroll-to-top-exit-active {
  transform: translateX(100%);
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/common/scrollToTop/scrollToTop.scss"],"names":[],"mappings":"AAKA;EAEC,2BAAA;EACA,UAAA;EACA,4BAAA;EAOA,eAAA;EACA,WAAA;EACA,YAAA;EAEA,YAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;EACA,oCAAA;EACA,8BAAA;EACA,2BAAA;AAZD;AAFC;EACC,aAAA;AAIF;AAWC;EAEC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EAEA,sBAAA;AAXF;AAcC;EACC,UAAA;EACA,0CAAA;AAZF;AAeC;EAEC,UAAA;EACA,yCAAA;AAdF;AAiBC;EA7CD;IA8CE,aAAA;EAdA;AACF;AAgBC;EACC;IACC,oCAAA;EAdD;AACF;;AAqBA;EACC,4BAAA;EACA,2BAAA;EACA,UAAA;AAlBD;;AAqBA;EACC,4BAAA;EACA,UAAA;EACA,yBAAA;AAlBD;;AAqBA;EACC,4BAAA;EACA,UAAA;EACA,yBAAA;AAlBD;;AAqBA;EACC,UAAA;EACA,yBAAA;AAlBD;;AAqBA;EACC,2BAAA;EACA,UAAA;AAlBD","sourcesContent":["@use 'sass:math';\r\n@import '../../../assets/scss/variable-settings.scss';\r\n@import '../../../assets/scss/mixins.scss';\r\n@import '../../../assets/scss/variables.scss';\r\n\r\n.scroll-to-top {\r\n\t// animation: fadeInRight 0.3s ease;\r\n\ttransform: translateX(100%);\r\n\topacity: 0;\r\n\ttransition: all 0.3s ease 0s;\r\n\t// &__button {\r\n\r\n\t&:empty {\r\n\t\tdisplay: none;\r\n\t}\r\n\r\n\tposition: fixed;\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\r\n\tz-index: 999;\r\n\tright: 0;\r\n\tbottom: 125px;\r\n\tpadding: 5px;\r\n\tbackground-color: rgba(0, 0, 0, .3);\r\n\tborder-bottom-left-radius: 5px;\r\n\tborder-top-left-radius: 5px;\r\n\r\n\t&::before,\r\n\t&::after {\r\n\t\tcontent: '';\r\n\t\tposition: absolute;\r\n\t\twidth: 10px;\r\n\t\theight: 2px;\r\n\t\ttop: 50%;\r\n\t\t// left: 50%;\r\n\t\tbackground-color: #fff;\r\n\t}\r\n\r\n\t&::before {\r\n\t\tleft: 13px;\r\n\t\ttransform: translateY(-50%) rotate(-45deg);\r\n\t}\r\n\r\n\t&::after {\r\n\t\t// right: 11px;\r\n\t\tleft: 19px;\r\n\t\ttransform: translateY(-50%) rotate(45deg);\r\n\t}\r\n\r\n\t@media (max-width:$tablet) {\r\n\t\tdisplay: none;\r\n\t}\r\n\r\n\t@media (any-hover: hover) {\r\n\t\t&:hover {\r\n\t\t\tbackground-color: rgba(0, 0, 0, .5);\r\n\t\t}\r\n\t}\r\n\r\n\t// }\r\n\r\n}\r\n\r\n.scroll-to-top-enter {\r\n\ttransition: all 0.3s ease 0s;\r\n\ttransform: translateX(100%);\r\n\topacity: 0;\r\n}\r\n\r\n.scroll-to-top-enter-active {\r\n\ttransition: all 0.3s ease 0s;\r\n\topacity: 1;\r\n\ttransform: translateX(0%);\r\n}\r\n\r\n.scroll-to-top-enter-done {\r\n\ttransition: all 0.3s ease 0s;\r\n\topacity: 1;\r\n\ttransform: translateX(0%);\r\n}\r\n\r\n.scroll-to-top-exit {\r\n\topacity: 1;\r\n\ttransform: translateX(0%);\r\n}\r\n\r\n.scroll-to-top-exit-active {\r\n\ttransform: translateX(100%);\r\n\topacity: 0;\r\n}\r\n\r\n// @keyframes fadeInRight {\r\n// \t0% {\r\n// \t\topacity: 0;\r\n// \t\ttransform: translateX(100%);\r\n// \t}\r\n\r\n// \t100% {\r\n// \t\topacity: 1;\r\n// \t\ttransform: translateX(0);\r\n// \t}\r\n// }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
